import { FETCH_CLIMB_DIFFICULTIES, FETCH_CLIMB_DIFFICULTIES_SUCCESS } from 'actions/dailySummaryActions.js';

const INITIAL_STATE = {
    indoorClimbDifficulty: {}
};

// ======= Fetching Handlers =======

const fetchRouteDifficultiesSuccess = (state, action) => {
    return {
        ...action.indoorClimbDifficulty
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_CLIMB_DIFFICULTIES_SUCCESS]: fetchRouteDifficultiesSuccess
};

// ======= Default Action =======
export default function indoorClimbDifficulty(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchRouteDifficulties(evictCache) {
    return {
        type: FETCH_CLIMB_DIFFICULTIES,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

// ======= Selectors =======

export const getIndoorClimbDifficulty = (state) => {
    return state.indoorClimbDifficulty;
};
